import { queryKeys } from '@/lib/query-keys';
import { adminSyncClient } from '@/lib/api/ts-rest';
import type { SyncRunKind } from '@octave/contracts';
import { useQuery } from '@tanstack/react-query';


export const useSyncOverview = () => {
  return useQuery({
    queryKey: queryKeys.adminSync.overview(),
    queryFn: async () => {
      const res = await adminSyncClient.getSyncOverview();
      if (res.status !== 200) throw new Error('Failed to load overview');
      return res.body;
    },
    refetchInterval: 30_000,
  });
};

export const useOrganizationsSyncStats = () => {
  return useQuery({
    queryKey: queryKeys.adminSync.organizations(),
    queryFn: async () => {
      const res = await adminSyncClient.getOrganizationsSyncStats();
      if (res.status !== 200) throw new Error('Failed to load stats');
      return res.body;
    },
    refetchInterval: 30_000,
  });
};

export const useSyncHistory = (limit = 50, kind?: SyncRunKind) => {
  return useQuery({
    queryKey: queryKeys.adminSync.history(limit, kind ?? 'all'),
    queryFn: async () => {
      const res = await adminSyncClient.getSyncHistory({
        query: { limit, kind },
      });
      if (res.status !== 200) throw new Error('Failed to load history');
      return res.body;
    },
    refetchInterval: 30_000,
  });
};
